// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Info from "@insite/mobius/Icons/Info";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { xBaseTheme } from "@turnerBlueprint/XDL/types";
import { color } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        cssOverrides: {
            tooltipWrapper: css`
                line-height: 0;
                display: inline-block;
            `,
            tooltipContainer: css`
                background-color: ${color("common.white")};
                max-width: 240px;
                border-radius: 0;
                min-width: 140px;
                box-shadow: 0 2px 4px 0 ${color("common.black", 0.1)};
                border: 1px solid ${color("common.border")};
            `,
            tooltipBody: css`
                display: flex;
                flex-direction: column;
                flex: 0 0 auto;
                padding: 12px;
            `,
            tooltipClickable: css`
                margin-left: 8px;
                margin-right: 8px;
            `,
        },
        iconProps: {
            src: Info,
            size: 12,
            color: "common.ui8",
            css: css``,
        },
        typographyProps: {
            size: 14,
            weight: fontConfig.weight.regular,
            color: "text.main",
            css: css`
                line-height: 22px;
                text-align: left;
                letter-spacing: 0;
                white-space: break-spaces;
                word-break: break-word;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    },
} as xBaseTheme["tooltip"];
